import { makeStyles } from '@material-ui/core'
import searchIcon from '../../assets/images/search.svg'

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },

  headerCheckbox: {
    color: '#fff',
    '& span': {
      color: '#fff'
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  filters: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    marginRight: 30,
    padding: '12px 10px 10px',
    borderBottom: '2px solid #30287b'
  },
  sorting: {
    height: '100%',
    fontSize: '12px',
    color: '#30287b',
    border: 'none',
    '& option:disabled': {
      display: 'none'
    }
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    marginTop: '20px',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead th': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase',
      '& .MuiCheckbox-root': {
        color: '#fff'
      }
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b',
      '& span': {
        display: 'flex',
        wordWrap: 'break-word'
      },
      '& .post-title': {
        fontWeight: 'bold',
        maxWidth: '250px'
      },
      '&:first-child span': {
        display: 'inline-flex'
      }
    },
    '& .scheduled td .datetime': {
      opacity: 0.5,
      fontWeight: 'bold'
    },
    '& a': {
      fontSize: 12,
      color: '#30287b',
      cursor: 'pointer',
      margin: '0 5px',
      '&.link-delete': {
        color: '#d73f32',
        '&:hover': {
          textDecoration: 'underline'
        }
      }
    }
  },
  checkboxHighlight: {
    textAlign: 'center'
  },
  updateButton: {
    margin: 0,
    color: '#FFF',
    lineHeight: '5px'
  },
  groupsColumn: {
    maxWidth: '200px'
  },
  chip: {
    borderRadius: '2px',
    fontWeight: 'bold',
    color: '#30287b',
    backgroundColor: '#ffce44'
  },
  actionsBtn: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: 'var(--secondary-color)',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer',
    '&:hover': {
      background: 'var(--yellow-highlight)'
    }
  },
  hide: {
    display: 'none'
  }
})

export default useStyles
